import { Button, Flex, SimpleGrid } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { DatesRangeValue } from "@mantine/dates/lib/types/DatePickerValue";
import { filter } from "lodash";
import isNil from "lodash/isNil";

import { useCollateralsBuyerNumber } from "../../../../../api/hooks/collateral/useCollateralsBuyerNumber.ts";
import SvgCalendar from "../../../../../components/Icons/Calendar.tsx";
import SvgPlus from "../../../../../components/Icons/Plus.tsx";
import { MultiSelect } from "../../../../../components/MultiSelect.tsx";
import { Select } from "../../../../../components/Select.tsx";
import { OrderBy } from "../../../../../graphql/generated.ts";
import {
  giroStatusOptions,
  giroTypeOptions,
} from "../../../../../types/collateral.ts";

interface GiroManagementToolbarProps {
  customerId: number;
  canEdit: boolean;
  onModalOpen: () => void;
  onFilterChange: (
    key: string,
    value: string | string[] | DatesRangeValue | null
  ) => void;
}

const GiroManagementToolbar = ({
  customerId,
  canEdit,
  onModalOpen,
  onFilterChange,
}: GiroManagementToolbarProps) => {
  const [{ data, fetching }] = useCollateralsBuyerNumber({
    filter: {
      customerId: { equals: customerId },
      collateralBuyerNumber: { not: null },
    },
    orderBy: { collateralBuyerNumber: OrderBy.Asc },
  });
  const buyerNumbers = filter(
    (data?.collaterals.data ?? []).map((item) => ({
      value: item.collateralBuyerNumber,
      label: item.collateralBuyerNumber,
    })),
    (item) => !isNil(item.value)
  );

  return (
    <Flex direction="column" gap={16} pb={4}>
      {canEdit && (
        <Button
          uppercase
          variant="filledGolden"
          leftIcon={<SvgPlus />}
          onClick={onModalOpen}
        >
          Add
        </Button>
      )}
      <SimpleGrid
        cols={4}
        breakpoints={[
          { maxWidth: "sm", cols: 2 },
          { maxWidth: "lg", cols: 5 },
        ]}
        spacing={20}
        verticalSpacing={8}
      >
        <Select
          size="m"
          clearable
          label="Giro Type"
          placeholder="Select Giro Type"
          data={giroTypeOptions}
          onChange={(value: string) => onFilterChange("type", value)}
        />
        <Select
          size="m"
          clearable
          label="Giro Status"
          placeholder="Select Giro Status"
          data={giroStatusOptions}
          onChange={(value: string) => onFilterChange("status", value)}
        />
        <DatePickerInput
          type="range"
          label="Giro Due Date Period"
          placeholder="Select Giro Due Date Period"
          icon={<SvgCalendar />}
          firstDayOfWeek={0}
          size="m"
          clearable
          onChange={(value: DatesRangeValue) =>
            onFilterChange("dueDate", value)
          }
        />
        <MultiSelect
          loading={fetching}
          size="m"
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          data={buyerNumbers}
          label="GIRO Buyer No"
          placeholder="Select GIRO Buyer No"
          searchable
          onChange={(value: string[]) =>
            onFilterChange("collateralBuyerNumber", value)
          }
        />
      </SimpleGrid>
    </Flex>
  );
};

export default GiroManagementToolbar;
